import gql from 'graphql-tag'

export const MUTATION_PRODUCTS_COMPARISONS_REPORT_PAYLOAD = gql`
  mutation CreateProductsComparisonsReport(
    $emails: [String!]!
    $fileFormat: FileFormatType!
    $firstPeriod: [String!]!
    $groupByUnit: Boolean
    $products: [String!]!
    $secondPeriod: [String!]!
    $unitsConfiguration: [UnitConfigurationInput!]!
  ) {
    createProductsComparisonsReport(
      emails: $emails
      fileFormat: $fileFormat
      firstPeriod: $firstPeriod
      groupByUnit: $groupByUnit
      products: $products
      secondPeriod: $secondPeriod
      unitsConfiguration: $unitsConfiguration
    ) {
      payload {
        emails
        fileFormat
        firstPeriod
        groupByUnit
        products
        secondPeriod
        unitsConfiguration {
          dataType
          value
        }
      }
    }
  }
`
